import React from "react";
import CppHeader from "./CppHeader";
import CppHero from "./CppHero";
import CppCurriculum from "./CppCurriculum";
import CppFeatures from "./CppFeatures";
import CppRequirements from "./CppRequirements";
import CppContact from "./CppContact";
import CppTeacherInfo from "./CppTeacherInfo";
import CppFooter from "./CppFooter";
import ToastContainer from "../Toast";
import { useToast } from "../../hooks/useToast";
import "./cpp-styles.css";

function CppApp() {
  const { toasts, removeToast } = useToast();
  
  return (
    <div className="cpp-app">
      <CppHeader />
      <CppHero />
      <CppCurriculum />
      <CppFeatures />
      <CppRequirements />
      <CppContact />
      <CppTeacherInfo />
      <CppFooter />
      <ToastContainer toasts={toasts} onRemove={removeToast} />
    </div>
  );
}

export default CppApp;